import React from "react";

const SEVERITY_CLASSES = {
  critical: "bg-[#D0021B] text-white",
  warning: "bg-[#F5A623] text-black",
  info: "bg-[#0055FF] text-white",
  safe: "bg-emerald-700 text-white",
};

const SEVERITY_LABEL = {
  critical: "Kritis",
  warning: "Peringatan",
  info: "Informasi",
  safe: "Aman",
};

export default function SeverityBadge({ severity, children, testId }) {
  const cls = SEVERITY_CLASSES[severity] || "bg-zinc-600 text-white";
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider rounded ${cls}`}
      data-testid={testId}
    >
      {children || SEVERITY_LABEL[severity] || severity}
    </span>
  );
}
